import DOMPurify from "dompurify"

export const EDITOR_HTML_SANITIZE_ATTRS = [
  "data-type",
  "data-latex",
  "data-content-type",
  "data-diagram-xml",
  "data-ocr-type",
  "style",
  "width",
  "height",
  "colspan",
  "rowspan",
  "colwidth",
  "data-colwidth",
] as const

export const sanitizeEditorHtml = (html: string): string =>
  DOMPurify.sanitize(html, {
    ADD_ATTR: [...EDITOR_HTML_SANITIZE_ATTRS],
  })
